import { withStyles } from '@material-ui/core/styles'
import map from 'lodash/map'
import { connect } from 'react-redux'
import { dashboardButtonsConfig } from '../services/dashboard-constants'
import styles from '../style'
import DashboardButtonComponent from './DashboardButton'

const DashboardButtonsContainer = (props) => {
  const { history, mainPageValues, classes } = props

  return (
    <div className={classes.container}>
      {map(dashboardButtonsConfig, (item) => (
        <DashboardButtonComponent
          key={item.title}
          item={item}
          history={history}
          mainPageValues={mainPageValues}
          id={item.id}
        />
      ))}
    </div>
  )
}

const mapStateToProps = (state) => ({
  mainPageValues: state.dashboardReducer.mainPageValues,
})

export default connect(mapStateToProps)(
  withStyles(styles)(DashboardButtonsContainer)
)
